import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

import { getTranslation } from '../../../utils/translations';

const MarketConfigurationSection = ({ countries, onRefresh, language }) => {
  const t = getTranslation(language);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const getRegionColor = (region) => {
    const colors = {
      'Western Europe': 'bg-blue-100 text-blue-700',
      'Eastern Europe': 'bg-purple-100 text-purple-700',
      'Southern Europe': 'bg-orange-100 text-orange-700',
      'Northern Europe': 'bg-teal-100 text-teal-700'
    };
    return colors?.[region] || 'bg-gray-100 text-gray-700';
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {countries?.map((country) => (
          <div
            key={country?.id}
            className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
            onClick={() => setSelectedCountry(country)}
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-semibold text-foreground text-lg">{country?.countryName}</h3>
                <p className="text-sm text-muted-foreground">{country?.countryCode}</p>
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                country?.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
              }`}>
                {country?.isActive ? (t?.common?.active || 'Active') : (t?.common?.inactive || 'Inactive')}
              </span>
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{t?.international?.region || 'Region'}:</span>
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getRegionColor(country?.region?.region_name || country?.region?.regionName || 'N/A')}`}>
                  {country?.region?.region_name || country?.region?.regionName || 'N/A'}
                </span>
              </div>

              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{t?.international?.currency || 'Currency'}:</span>
                <span className="font-medium text-foreground">{country?.currencyCode}</span>
              </div>

              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{t?.international?.taxRate || 'Tax Rate'}:</span>
                <span className="font-medium text-foreground">{country?.taxRate}%</span>
              </div>

              <div className="mt-3 pt-3 border-t border-border">
                <p className="text-xs text-muted-foreground mb-2">{t?.international?.paymentMethods || 'Payment Methods'}:</p>
                <div className="flex flex-wrap gap-1">
                  {country?.paymentMethods?.slice(0, 3)?.map((method, idx) => (
                    <span key={idx} className="px-2 py-0.5 bg-muted text-muted-foreground rounded text-xs">
                      {method}
                    </span>
                  ))}
                  {country?.paymentMethods?.length > 3 && (
                    <span className="px-2 py-0.5 bg-muted text-muted-foreground rounded text-xs">
                      +{country?.paymentMethods?.length - 3}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {countries?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Globe" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">{t?.common?.noData || 'No data available'}</p>
        </div>
      )}
    </div>
  );
};

export default MarketConfigurationSection;